var React = require('react');

function MouseCircle (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"24","fill":"currentColor","key":0}),React.createElement("path",{"d":"M32.96 29.84L31.33 30.39C30.88 30.54 30.52 30.89 30.37 31.35L29.82 32.98C29.35 34.39 27.37 34.36 26.93 32.95L25.08 27C24.72 25.82 25.8101 24.72 26.9801 25.09L32.94 26.94C34.34 27.38 34.36 29.37 32.96 29.84Z","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M34 24C34 18.48 29.52 14 24 14C18.48 14 14 18.48 14 24C14 29.52 18.48 34 24 34","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

MouseCircle.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 48 48","fill":"none"};

module.exports = MouseCircle;

MouseCircle.default = MouseCircle;
